/**
 * RideRite YMM Widget v2.1
 * YEAR-ONLY filtering on make+model collections | Year range 1980-2027
 *
 * Fix (v8.2): collection destinations are already per-make+model collections
 * (e.g. /collections/chevrolet-corvette), so fitment is filtered by YEAR alone.
 * Shopify OR-combines repeated filter.p.tag values, so appending make/model tags
 * returned every year of the model. A single year tag = exact match = correct.
 */
(function() {
  'use strict';
  var STORAGE_KEY = 'rr_garage';
  var PAUSED_KEY  = 'rr_garage_paused';
  var YEAR_MIN    = 1980;
  var YEAR_MAX    = 2027;
  var FIND_PARTS_PAGE = '/pages/find-parts';

  function getGarage() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null; } catch(e) { return null; } }
  function setGarage(v) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(v)); } catch(e) {} }
  function clearGarage() { try { localStorage.removeItem(STORAGE_KEY); sessionStorage.removeItem(PAUSED_KEY); } catch(e) {} }
  function isPaused() { try { return sessionStorage.getItem(PAUSED_KEY) === '1'; } catch(e) { return false; } }
  function setPaused(v) { try { sessionStorage.setItem(PAUSED_KEY, v ? '1' : '0'); } catch(e) {} }

  function tagMatch(tags, value) {
    var v = String(value).toLowerCase().trim();
    return tags.some(function(t) { return String(t).toLowerCase().trim() === v; });
  }

  // YEAR-ONLY filter. The destination is the make+model collection, so the
  // collection itself scopes make+model; we only add the year tag. Appending
  // make/model here would trigger Shopify's OR-combine and return every year.
  function buildFilteredUrl(baseUrl, garage) {
    if (!garage) return baseUrl;
    try {
      var url = new URL(baseUrl, window.location.origin);
      url.searchParams.delete('filter.p.tag');
      url.searchParams.append('filter.p.tag', String(garage.year));
      return url.toString();
    } catch(e) { return baseUrl; }
  }

  function buildFindPartsUrl(year, make, model, collectionUrl) {
    var url = new URL(FIND_PARTS_PAGE, window.location.origin);
    url.searchParams.set('year', year);
    url.searchParams.set('make', make);
    url.searchParams.set('model', model);
    if (collectionUrl) url.searchParams.set('url', collectionUrl);
    return url.toString();
  }

  function injectGarageFilters() {
    document.addEventListener('click', function(e) {
      var target = e.target;
      while (target && target.tagName !== 'A') target = target.parentElement;
      if (!target || !target.href) return;
      try {
        var url = new URL(target.href);
        if (url.origin !== window.location.origin) return;
        if (!url.pathname.startsWith('/collections/')) return;
        if (url.searchParams.has('filter.p.tag')) return;
        if (target.classList.contains('rr-gb__shop')) return;
        if (target.classList.contains('rr-fp__tile')) return;
        var g = getGarage();
        if (!g || isPaused()) return;
        e.preventDefault();
        window.location.href = buildFilteredUrl(target.href, g);
      } catch(err) {}
    }, true);
  }

  function watchFacetChanges() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.id || form.id.indexOf('FacetFiltersForm') !== 0) return;
      var formData = new FormData(form);
      var tags = [];
      formData.forEach(function(v, k) { if (k === 'filter.p.tag') tags.push(v.toLowerCase()); });
      var g = getGarage();
      if (!g) return;
      // Year-only: paused if the garage year tag is no longer applied.
      var ok = tags.indexOf(String(g.year)) !== -1;
      setPaused(!ok);
    }, true);
    document.addEventListener('click', function(e) {
      var target = e.target;
      while (target && target.tagName !== 'A') target = target.parentElement;
      if (!target) return;
      if (target.classList.contains('active-facets__button') || target.closest('.active-facets')) {
        var href = target.href || '';
        if (!href) return;
        try {
          var url  = new URL(href);
          var tags = url.searchParams.getAll('filter.p.tag').map(function(t) { return t.toLowerCase(); });
          var g = getGarage();
          if (!g) return;
          // Year-only: paused if the garage year tag is no longer applied.
          var ok = tags.indexOf(String(g.year)) !== -1;
          if (!ok) setPaused(true);
        } catch(err) {}
      }
    }, true);
  }

  function renderGarageBar() {
    var existing = document.getElementById('rr-garage-bar');
    if (existing) existing.remove();
    var g = getGarage();
    if (!g) return;
    var paused  = isPaused();
    var shopUrl = buildFindPartsUrl(g.year, g.make, g.model, g.url);
    var bar = document.createElement('div');
    bar.id = 'rr-garage-bar';
    bar.innerHTML =
      '<div class="rr-gb__inner">' +
        '<span class="rr-gb__label">My Garage:</span>' +
        '<span class="rr-gb__vehicle">' + g.year + ' ' + g.make + ' ' + g.model + '</span>' +
        '<a href="' + shopUrl + '" class="rr-gb__shop">Shop Parts</a>' +
        '<button class="rr-gb__toggle ' + (paused ? 'rr-gb__toggle--off' : 'rr-gb__toggle--on') + '" id="rr-gb-toggle">' +
          (paused ? '&#9898; Show All' : '&#10003; My Car') +
        '</button>' +
        '<button class="rr-gb__clear" onclick="window.RR.clearVehicle()" title="Remove vehicle">&#10005;</button>' +
      '</div>';
    var headerGroup = document.getElementById('header-group');
    if (headerGroup && headerGroup.nextSibling) {
      headerGroup.parentNode.insertBefore(bar, headerGroup.nextSibling);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
    var toggleBtn = document.getElementById('rr-gb-toggle');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function() {
        var nowPaused = isPaused();
        setPaused(!nowPaused);
        if (nowPaused) {
          if (window.location.pathname.startsWith('/collections/')) {
            window.location.href = buildFilteredUrl(window.location.href.split('?')[0], g);
          }
        } else {
          if (window.location.pathname.startsWith('/collections/')) {
            try {
              var url  = new URL(window.location.href);
              var tags = url.searchParams.getAll('filter.p.tag');
              url.searchParams.delete('filter.p.tag');
              var yearLow  = String(g.year);
              var makeLow  = g.make.toLowerCase();
              var modelLow = g.model.toLowerCase();
              tags.forEach(function(t) {
                var tl = t.toLowerCase();
                if (tl !== yearLow && tl !== makeLow && tl !== modelLow) {
                  url.searchParams.append('filter.p.tag', t);
                }
              });
              window.location.href = url.toString();
            } catch(err) { window.location.reload(); }
          }
        }
        renderGarageBar();
      });
    }
  }

  function renderFitmentBadge() {
    if (!window.location.pathname.startsWith('/products/')) return;
    var tags = [];
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      tags = window.ShopifyAnalytics.meta.product.tags || [];
    }
    if (!tags.length) {
      var el = document.querySelector('[data-product-json], script[type="application/json"][id*="product"]');
      if (el) { try { tags = JSON.parse(el.textContent).tags || []; } catch(e) {} }
    }
    var old = document.getElementById('rr-fitment-badge');
    if (old) old.remove();
    var badge = document.createElement('div');
    badge.id = 'rr-fitment-badge';
    var g = getGarage();
    if (!g) {
      badge.className = 'rr-fit rr-fit--unknown';
      badge.innerHTML = '<a href="/pages/part-search" class="rr-fit__link">Select your vehicle</a> to check fitment';
    } else {
      var hasYear  = tagMatch(tags, String(g.year));
      var hasMake  = tagMatch(tags, g.make);
      var hasModel = tagMatch(tags, g.model);
      var vehicle  = '<strong>' + g.year + ' ' + g.make + ' ' + g.model + '</strong>';
      if (hasYear && hasMake && hasModel) {
        badge.className = 'rr-fit rr-fit--yes';
        badge.innerHTML = '<span class="rr-fit__icon">&#10003;</span> Fits your ' + vehicle;
      } else if (hasMake && hasModel) {
        badge.className = 'rr-fit rr-fit--maybe';
        badge.innerHTML = '<span class="rr-fit__icon">&#9888;</span> Fits ' + g.make + ' ' + g.model + ' &mdash; verify year range before ordering';
      } else if (hasMake) {
        badge.className = 'rr-fit rr-fit--maybe';
        badge.innerHTML = '<span class="rr-fit__icon">&#9888;</span> May fit your ' + vehicle + ' &mdash; confirm fitment before ordering';
      } else {
        badge.className = 'rr-fit rr-fit--no';
        badge.innerHTML = '<span class="rr-fit__icon">&#10007;</span> May not fit your ' + vehicle + ' &mdash; <a href="/pages/part-search" class="rr-fit__link">find parts that do</a>';
      }
    }
    var targets = ['.product-details__buy-buttons','.product-form__buttons','[data-type="add-to-cart-form"]','.product__submit','form[action="/cart/add"]','.buy-buttons'];
    var inserted = false;
    for (var i = 0; i < targets.length; i++) {
      var t = document.querySelector(targets[i]);
      if (t) { t.parentNode.insertBefore(badge, t); inserted = true; break; }
    }
    if (!inserted) {
      var details = document.querySelector('.product-details, .product-information, .product__info-wrapper, .product-single__meta');
      if (details) details.appendChild(badge);
    }
  }

  function buildWidget(container) {
    if (!window.RR_YMM) {
      container.innerHTML = '<p style="color:#888;font-size:.85rem;padding:8px 0">Loading vehicle data...</p>';
      var t = setInterval(function() { if (window.RR_YMM) { clearInterval(t); buildWidget(container); } }, 200);
      return;
    }
    var data  = window.RR_YMM;
    var makes = Object.keys(data).sort();
    container.innerHTML =
      '<div class="rr-ymm-w">' +
        '<div class="rr-ymm-w__row">' +
          '<div class="rr-ymm-w__field"><label class="rr-ymm-w__lbl">Year</label><select class="rr-ymm-w__sel" id="rr-sel-year"><option value="">Select Year</option></select></div>' +
          '<div class="rr-ymm-w__field"><label class="rr-ymm-w__lbl">Make</label><select class="rr-ymm-w__sel" id="rr-sel-make" disabled><option value="">Select Make</option></select></div>' +
          '<div class="rr-ymm-w__field"><label class="rr-ymm-w__lbl">Model</label><select class="rr-ymm-w__sel" id="rr-sel-model" disabled><option value="">Select Model</option></select></div>' +
        '</div>' +
        '<button class="rr-ymm-w__btn" id="rr-ymm-go" disabled>Find My Parts &rarr;</button>' +
      '</div>';
    var selYear  = document.getElementById('rr-sel-year');
    var selMake  = document.getElementById('rr-sel-make');
    var selModel = document.getElementById('rr-sel-model');
    var btnGo    = document.getElementById('rr-ymm-go');
    for (var y = YEAR_MAX; y >= YEAR_MIN; y--) {
      var opt = document.createElement('option'); opt.value = y; opt.textContent = y; selYear.appendChild(opt);
    }
    var g = getGarage();
    if (g) { selYear.value = g.year; populateMakes(); selMake.value = g.make; populateModels(); selModel.value = g.model; btnGo.disabled = !selModel.value; }
    function populateMakes() {
      selMake.innerHTML = '<option value="">Select Make</option>'; selMake.disabled = false;
      makes.forEach(function(m) { var o = document.createElement('option'); o.value = m; o.textContent = m; selMake.appendChild(o); });
    }
    function populateModels() {
      var make = selMake.value; selModel.innerHTML = '<option value="">Select Model</option>';
      if (!make || !data[make]) return; selModel.disabled = false;
      Object.keys(data[make]).sort().forEach(function(m) { var o = document.createElement('option'); o.value = m; o.textContent = m; selModel.appendChild(o); });
    }
    selYear.addEventListener('change', function() { selMake.innerHTML='<option value="">Select Make</option>'; selMake.disabled=true; selModel.innerHTML='<option value="">Select Model</option>'; selModel.disabled=true; btnGo.disabled=true; if(this.value) populateMakes(); });
    selMake.addEventListener('change', function() { selModel.innerHTML='<option value="">Select Model</option>'; selModel.disabled=true; btnGo.disabled=true; if(this.value) populateModels(); });
    selModel.addEventListener('change', function() { btnGo.disabled = !this.value; });
    btnGo.addEventListener('click', function() {
      var year = selYear.value, make = selMake.value, model = selModel.value;
      if (!year || !make || !model) return;
      var collectionUrl = (data[make] && data[make][model]) ? data[make][model] : '/collections/all';
      setGarage({ year: year, make: make, model: model, url: collectionUrl });
      setPaused(false); renderGarageBar();
      window.location.href = buildFindPartsUrl(year, make, model, collectionUrl);
    });
  }

  window.RR = window.RR || {};
  window.RR.clearVehicle = function() {
    clearGarage();
    var bar = document.getElementById('rr-garage-bar'); if (bar) bar.remove();
    var badge = document.getElementById('rr-fitment-badge'); if (badge) badge.remove();
    if (window.location.pathname.startsWith('/collections/')) {
      try { var url = new URL(window.location.href); url.searchParams.delete('filter.p.tag'); window.location.replace(url.toString()); } catch(e) { window.location.reload(); }
    }
    if (window.location.pathname.startsWith('/products/')) renderFitmentBadge();
  };
  window.RR.initYMMWidget = function(container) { buildWidget(container); };

  function init() {
    renderGarageBar(); renderFitmentBadge(); injectGarageFilters(); watchFacetChanges();
    document.querySelectorAll('[data-rr-ymm]').forEach(function(el) { buildWidget(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
